import type { MediaItem } from '@/types/media';

export const mediaList: MediaItem[] = [
  {
    id: 1,
    title: '星海征途',
    type: 'movie',
    year: 2025,
    rating: 8.7,
    region: '国产',
    genres: ['科幻', '冒险'],
    director: '林澈',
    actors: ['周衍', '苏语棠', '陈牧野', '叶知秋'],
    duration: '142分钟',
    updatedAt: '2025-10-12',
    hot: 9821,
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20facing%20a%20colossal%20glowing%20wormhole%20in%20deep%20space%20moody%20dramatic%20lighting%20deep%20navy%20and%20warm%20amber%20grading%20high%20contrast%20professional%20key%20art%20rich%20atmospheric%20detail%20elegant%20composition%20no%20text&width=400&height=600&seq=ptv-poster-astro-01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20cinematic%20scene%20with%20a%20vast%20glowing%20spiral%20galaxy%20and%20distant%20spacecraft%20deep%20navy%20tones%20warm%20amber%20highlights%20dramatic%20atmospheric%20lighting%20film%20still%20quality%20rich%20detail%20no%20text&width=1200&height=675&seq=ptv-backdrop-astro-01&orientation=landscape',
    tagline: '穿越星海，只为抵达人类最后的前沿',
    synopsis:
      '在不远的未来，人类首次实现了稳定的星际跃迁。一艘名为「征途号」的探索舰承载着全人类的希望驶向未知星系，却意外卷入一场关乎文明存续的危机。舰长秦昭必须在有限的时间里，带领船员在陌生星域中寻找归途。',
    features:
      '影片以硬核科幻设定为骨架，用细腻的人物群像撑起情感内核。视效团队耗时三年打磨星际场景，配乐与镜头语言共同营造出浩瀚而孤独的宇宙氛围。',
  },
  {
    id: 2,
    title: '暗夜追凶',
    type: 'movie',
    year: 2024,
    rating: 8.3,
    region: '国产',
    genres: ['犯罪', '悬疑'],
    director: '高砚',
    actors: ['韩沉', '许清雨', '郑维', '孟秋'],
    duration: '128分钟',
    updatedAt: '2025-09-28',
    hot: 8712,
    poster:
      'https://readdy.ai/api/search-image?query=Neo-noir%20detective%20movie%20poster%20artwork%20of%20a%20silhouetted%20figure%20standing%20in%20rain%20soaked%20alley%20deep%20navy%20and%20cool%20blue%20shadows%20with%20a%20single%20amber%20street%20lamp%20high%20contrast%20moody%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-noir-02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Moody%20rainy%20city%20street%20at%20night%20with%20reflective%20wet%20asphalt%20and%20warm%20street%20lamp%20glow%20neo-noir%20cinematic%20film%20still%20deep%20navy%20tones%20atmospheric%20fog%20dramatic%20lighting%20no%20text&width=1200&height=675&seq=ptv-backdrop-noir-02&orientation=landscape',
    tagline: '真相往往藏在你最不愿直视的地方',
    synopsis:
      '连续三起看似毫无关联的案件，把退休刑警陆沉重新拉回了他最想逃离的城市。随着调查深入，他发现所有线索都指向十年前那桩未结悬案。这一次，他必须直面自己埋藏多年的秘密。',
    features:
      '叙事采用双时间线交错推进，悬念层层递进。摄影以低照度冷调为主，配合克制的表演，营造出压抑而真实的社会派悬疑质感。',
  },
  {
    id: 3,
    title: '心动信号',
    type: 'movie',
    year: 2025,
    rating: 7.9,
    region: '国产',
    genres: ['爱情', '喜剧'],
    director: '温筱',
    actors: ['柠宁', '顾南舟', '白梨', '曾一凡'],
    duration: '112分钟',
    updatedAt: '2025-10-05',
    hot: 7650,
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20romantic%20comedy%20movie%20poster%20artwork%20with%20two%20young%20people%20sharing%20an%20umbrella%20on%20a%20city%20street%20at%20dusk%20soft%20amber%20and%20coral%20lighting%20gentle%20bokeh%20background%20cheerful%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-romance-03&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20city%20park%20at%20sunset%20with%20warm%20amber%20sky%20and%20soft%20blurred%20lights%20of%20a%20street%20cafe%20romantic%20cinematic%20film%20still%20gentle%20glow%20dreamy%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-romance-03&orientation=landscape',
    tagline: '有些心动，藏在一句来不及说出口的晚安里',
    synopsis:
      '电台深夜主播苏迟靠声音治愈了无数陌生人，却唯独读不懂自己隔壁那位总是点同一首歌的邻居。一次意外的乌龙播报，让两条原本平行的生活线悄然交汇。',
    features:
      '轻盈幽默的对白搭配细腻的情绪描写，把都市男女的暧昧与试探拍得真实可爱。配乐以原声吉他为主，温暖治愈。',
  },
  {
    id: 4,
    title: '末日黎明',
    type: 'movie',
    year: 2025,
    rating: 8.9,
    region: '欧美',
    genres: ['科幻', '动作'],
    director: 'Dorian Vale',
    actors: ['Marcus Reed', 'Elena Cross', 'Ivan Novak', 'Sofia Hale'],
    duration: '136分钟',
    updatedAt: '2025-10-14',
    hot: 9930,
    poster:
      'https://readdy.ai/api/search-image?query=Post-apocalyptic%20action%20movie%20poster%20artwork%20of%20a%20rugged%20survivor%20silhouetted%20against%20a%20burning%20orange%20horizon%20over%20a%20ruined%20city%20dramatic%20high%20contrast%20deep%20charcoal%20and%20amber%20grading%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-apoc-04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Ruined%20futuristic%20city%20skyline%20under%20a%20smoldering%20ember%20orange%20dawn%20with%20drifting%20smoke%20and%20distant%20ruins%20cinematic%20film%20still%20high%20contrast%20atmospheric%20dust%20epic%20scale%20no%20text&width=1200&height=675&seq=ptv-backdrop-apoc-04&orientation=landscape',
    tagline: '当世界熄灯，总有人选择点亮黎明',
    synopsis:
      '一场全球性的能源崩溃让现代文明在一夜之间倒退百年。前工程兵艾登带领一群互不相识的幸存者，穿越被废墟与暴力割裂的大陆，只为抵达传说中仍在运转的「黎明站」。',
    features:
      '影片以宏大世界观包裹人性抉择，动作场面调度凌厉而不失真实。美术设计构建出一个可信的崩坏世界，节奏张弛有度。',
  },
  {
    id: 5,
    title: '无声告白',
    type: 'movie',
    year: 2023,
    rating: 8.5,
    region: '欧美',
    genres: ['剧情', '家庭'],
    director: 'Clara Bennett',
    actors: ['Nora Adler', 'Thomas Weir', 'Amelia Frost'],
    duration: '124分钟',
    updatedAt: '2025-08-20',
    hot: 6210,
    poster:
      'https://readdy.ai/api/search-image?query=Quiet%20emotional%20drama%20movie%20poster%20artwork%20of%20a%20single%20empty%20chair%20by%20a%20sunlit%20window%20muted%20dusk%20palette%20soft%20warm%20filtered%20light%20minimal%20elegant%20cinematic%20key%20art%20melancholic%20mood%20no%20text&width=400&height=600&seq=ptv-poster-drama-05&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Serene%20sunlit%20family%20living%20room%20with%20sheer%20curtains%20and%20warm%20dusty%20light%20golden%20hour%20tones%20soft%20focus%20cinematic%20film%20still%20quiet%20melancholic%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-drama-05&orientation=landscape',
    tagline: '有些爱，从未说出口，却从未离开',
    synopsis:
      '一个移民家庭在异乡努力扎根的十年里，母亲始终保留着一封从未寄出的信。当女儿决定卖掉老房子，那些被刻意遗忘的往事与未说出口的告白，终于浮出水面。',
    features:
      '影片以克制细腻的笔触描绘家庭关系中的沉默与误解，表演真实动人。光影运用极具诗意，将日常细节拍出深沉的情感重量。',
  },
  {
    id: 6,
    title: '极速狂飙',
    type: 'movie',
    year: 2024,
    rating: 8.1,
    region: '欧美',
    genres: ['动作', '犯罪'],
    director: 'Leo Marchetti',
    actors: ['Diego Ferrer', 'Mia Lang', 'Owen Brooks'],
    duration: '118分钟',
    updatedAt: '2025-09-10',
    hot: 7480,
    poster:
      'https://readdy.ai/api/search-image?query=High%20octane%20racing%20action%20movie%20poster%20artwork%20of%20a%20muscle%20car%20drifting%20through%20a%20night%20city%20with%20streaking%20amber%20light%20trails%20deep%20charcoal%20and%20orange%20grading%20motion%20blur%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-race-06&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Downtown%20night%20highway%20with%20long%20exposure%20amber%20light%20trails%20and%20rain%20gloss%20speed%20motion%20cinematic%20film%20still%20high%20contrast%20urban%20drama%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-race-06&orientation=landscape',
    tagline: '赛道之上，没有退路',
    synopsis:
      '前职业车手雷科为了偿还弟弟欠下的赌债，被迫重返地下飙车圈。在一场场危险的竞速中，他逐渐发现这背后隐藏着一个精心设计的陷阱，而操控者正是他最信任的老友。',
    features:
      '赛车场面全部实景拍摄，配合精准的剪辑营造出身临其境的速度感。故事在爽感之外，也探讨了亲情与背叛的代价。',
  },
  {
    id: 7,
    title: '樱花之约',
    type: 'movie',
    year: 2024,
    rating: 7.8,
    region: '日韩',
    genres: ['爱情', '剧情'],
    director: '中村悠介',
    actors: ['佐藤凛', '高桥崇', '小林绫'],
    duration: '106分钟',
    updatedAt: '2025-07-15',
    hot: 5340,
    poster:
      'https://readdy.ai/api/search-image?query=Soft%20romantic%20Japanese%20movie%20poster%20artwork%20of%20two%20figures%20under%20a%20blooming%20pink%20sakura%20tree%20by%20a%20quiet%20river%20gentle%20pastel%20pink%20and%20warm%20cream%20tones%20dreamy%20bokeh%20bokeh%20petals%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-sakura-07&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Tranquil%20Japanese%20riverside%20path%20lined%20with%20blooming%20sakura%20trees%20soft%20spring%20sunlight%20pink%20petals%20drifting%20gentle%20warm%20tones%20cinematic%20film%20still%20serene%20nostalgic%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-sakura-07&orientation=landscape',
    tagline: '每一年花开，我都替你记得',
    synopsis:
      '摄影师北川在整理祖母遗物时，发现一张每年春天都会在同一个樱花树下重拍的老照片。循着照片的线索，他遇见了一位守着约定的老人，也重新理解了承诺与等待的意义。',
    features:
      '影片节奏舒缓，画面如画。以季节流转为叙事线索，把一段跨越年代的约定拍得温柔而隽永，适合安静的午后独自观看。',
  },
  {
    id: 8,
    title: '深海迷航',
    type: 'movie',
    year: 2025,
    rating: 8.0,
    region: '国产',
    genres: ['冒险', '科幻', '悬疑'],
    director: '沈砚',
    actors: ['江屿', '路遥', '何洛', '程霜'],
    duration: '130分钟',
    updatedAt: '2025-09-30',
    hot: 8020,
    poster:
      'https://readdy.ai/api/search-image?query=Deep%20sea%20sci-fi%20thriller%20movie%20poster%20artwork%20of%20a%20submersible%20descending%20into%20a%20glowing%20abyssal%20trench%20dark%20teal%20and%20pale%20cyan%20bioluminescent%20lights%20mysterious%20moody%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-deepsea-08&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Vast%20glowing%20deep%20ocean%20trench%20with%20bioluminescent%20particles%20and%20distant%20marine%20snow%20dark%20teal%20water%20eerie%20volumetric%20light%20cinematic%20film%20still%20mysterious%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-deepsea-08&orientation=landscape',
    tagline: '越往下潜，越接近真相',
    synopsis:
      '一支国际深潜科研团队在太平洋马里亚纳海沟执行常规探测时，声呐捕捉到了一段不属于任何已知生物的规律性信号。随着下潜深度不断增加，船员们开始怀疑，他们探索的也许并不是未知的海洋。',
    features:
      '影片将科幻设定与幽闭恐惧融合，水下摄影质感一流。音效设计尤为出色，用声音制造出持续的压迫感与未知感。',
  },
  {
    id: 9,
    title: '时光信箱',
    type: 'movie',
    year: 2023,
    rating: 8.6,
    region: '国产',
    genres: ['剧情', '家庭'],
    director: '苏念',
    actors: ['老周', '林晚', '小满'],
    duration: '110分钟',
    updatedAt: '2025-06-18',
    hot: 5890,
    poster:
      'https://readdy.ai/api/search-image?query=Nostalgic%20family%20drama%20movie%20poster%20artwork%20of%20a%20weathered%20green%20mailbox%20at%20dusk%20with%20warm%20amber%20light%20soft%20grain%20muted%20warm%20palette%20gentle%20nostalgic%20mood%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-letter-09&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Old%20town%20street%20in%20warm%20golden%20hour%20with%20traditional%20houses%20and%20a%20solitary%20mailbox%20soft%20nostalgic%20warm%20tones%20cinematic%20film%20still%20gentle%20melancholic%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-letter-09&orientation=landscape',
    tagline: '写给过去的信，终会有人收到',
    synopsis:
      '退休邮差老周在整理废弃邮局时，发现了一批从未投递出去的信件。他决定按地址逐一送信，却意外牵出了一段尘封多年的邻里往事，也让自己与疏远的女儿重新靠近。',
    features:
      '影片用一封封信件串联起小镇上普通人的悲欢，情感真挚克制。表演自然朴实，让人想起自己身边的那些沉默的长辈。',
  },
  {
    id: 10,
    title: '长安烟云',
    type: 'tv',
    year: 2025,
    rating: 9.0,
    region: '国产',
    genres: ['古装', '剧情'],
    director: '裴清',
    actors: ['谢云舟', '温书意', '裴仲', '沈昭'],
    duration: '每集45分钟 / 共40集',
    updatedAt: '2025-10-15',
    hot: 9905,
    poster:
      'https://readdy.ai/api/search-image?query=Historical%20Chinese%20period%20drama%20poster%20artwork%20of%20lantern%20lit%20ancient%20palace%20at%20night%20with%20a%20lone%20robed%20figure%20deep%20indigo%20and%20warm%20amber%20lantern%20glow%20elegant%20ink%20painting%20atmosphere%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-changan-10&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sweeping%20view%20of%20ancient%20Chinese%20palace%20complex%20at%20dusk%20with%20warm%20lanterns%20and%20misty%20mountains%20deep%20indigo%20and%20amber%20tones%20epic%20cinematic%20period%20drama%20still%20no%20text&width=1200&height=675&seq=ptv-backdrop-changan-10&orientation=landscape',
    tagline: '长安三千灯火，照不亮人心的暗处',
    synopsis:
      '盛唐年间，一名出身寒门的年轻官员被卷入朝堂暗流。他在权谋、忠义与亲情之间艰难取舍，试图在风雨欲来的时代保全心中那份清白。以四十年为跨度，讲述一座城与一群人的命运沉浮。',
    features:
      '制作考究，服化道还原盛唐气象。剧本扎实，人物立体，每个配角都有完整的弧光，是近年少见的群像式历史剧。',
  },
  {
    id: 11,
    title: '都市迷情',
    type: 'tv',
    year: 2024,
    rating: 8.2,
    region: '国产',
    genres: ['都市', '爱情'],
    director: '罗曼',
    actors: ['顾湘', '霍研', '安琪', '周牧'],
    duration: '每集40分钟 / 共32集',
    updatedAt: '2025-09-22',
    hot: 8130,
    poster:
      'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20drama%20poster%20artwork%20of%20a%20young%20woman%20silhouette%20against%20neon%20city%20night%20lights%20teal%20and%20warm%20amber%20bokeh%20sleek%20contemporary%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-city-11&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Contemporary%20city%20skyline%20at%20blue%20hour%20with%20warm%20window%20lights%20and%20teal%20sky%20reflections%20on%20glass%20buildings%20sleek%20cinematic%20urban%20drama%20still%20no%20text&width=1200&height=675&seq=ptv-backdrop-city-11&orientation=landscape',
    tagline: '在千万人的城市里，找到一个人',
    synopsis:
      '三十岁那年，事业稳定的顾湘突然被裁，被迫重新开始。在一间合租公寓里，她遇见了几位同样在城市里漂泊的年轻人。他们的相遇、争吵与扶持，拼凑出当代都市最真实的情感图景。',
    features:
      '剧集贴近现实，聚焦职场、租房与亲密关系等话题。台词扎心而幽默，几组人物关系交织，展现都市生活的多面性。',
  },
  {
    id: 12,
    title: '破晓行动',
    type: 'tv',
    year: 2025,
    rating: 8.8,
    region: '国产',
    genres: ['悬疑', '犯罪', '动作'],
    director: '严峻',
    actors: ['陆铮', '苏槐', '宁越', '邱然'],
    duration: '每集42分钟 / 共36集',
    updatedAt: '2025-10-10',
    hot: 9450,
    poster:
      'https://readdy.ai/api/search-image?query=Tense%20crime%20thriller%20series%20poster%20artwork%20of%20city%20lights%20seen%20through%20cracked%20glass%20deep%20navy%20and%20cool%20steel%20tones%20with%20amber%20accent%20high%20contrast%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-dawn-12&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Rainy%20downtown%20city%20at%20predawn%20with%20cool%20steel%20tones%20and%20warm%20police%20lights%20reflecting%20on%20wet%20streets%20cinematic%20crime%20series%20still%20moody%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-dawn-12&orientation=landscape',
    tagline: '天亮之前，必须结案',
    synopsis:
      '一支临危受命的专案组，接手了一宗牵涉甚广的连环案件。在有限的时间里，他们必须在各方压力下拼凑出完整真相。每个人都背负着自己的秘密，而真相的代价远比想象中沉重。',
    features:
      '节奏紧凑，每集都有信息量。案件设计环环相扣，同时深入刻画警察群体的职业困境与情感世界，兼具悬疑张力与人文关怀。',
  },
  {
    id: 13,
    title: '王座之争',
    type: 'tv',
    year: 2024,
    rating: 9.2,
    region: '欧美',
    genres: ['奇幻', '剧情', '冒险'],
    director: 'Edmund Blackwood',
    actors: ['Alaric Storm', 'Serena Vale', 'Cassian Reed', 'Lyra Frost'],
    duration: '每集55分钟 / 共28集',
    updatedAt: '2025-10-08',
    hot: 9980,
    poster:
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20series%20poster%20artwork%20of%20an%20ornate%20iron%20throne%20in%20a%20vast%20dark%20hall%20deep%20indigo%20shadows%20and%20cold%20amber%20torchlight%20dramatic%20high%20contrast%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-throne-13&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Colossal%20fantasy%20castle%20hall%20at%20night%20with%20towering%20stone%20pillars%20and%20warm%20torchlight%20misty%20atmosphere%20deep%20indigo%20and%20amber%20cinematic%20film%20still%20epic%20scale%20no%20text&width=1200&height=675&seq=ptv-backdrop-throne-13&orientation=landscape',
    tagline: '权力是一场无人能全身而退的游戏',
    synopsis:
      '七大王国在脆弱的和平中暗流涌动。当老王驾崩，继承权之争彻底点燃了积压多年的矛盾。从宫廷阴谋到边境战场，无数家族的命运被卷入这场波澜壮阔的权力漩涡。',
    features:
      '世界观宏大，多条叙事线并行推进却丝毫不乱。人物塑造复杂多面，没有绝对的善恶，服化道与特效制作精良，堪称史诗级奇幻巨制。',
  },
  {
    id: 14,
    title: '午夜诊所',
    type: 'tv',
    year: 2023,
    rating: 8.0,
    region: '欧美',
    genres: ['恐怖', '悬疑'],
    director: 'Helena Moore',
    actors: ['Grace Hollow', 'Nathan Pike', 'Iris Bell'],
    duration: '每集48分钟 / 共20集',
    updatedAt: '2025-05-30',
    hot: 5620,
    poster:
      'https://readdy.ai/api/search-image?query=Eerie%20horror%20series%20poster%20artwork%20of%20a%20flickering%20hospital%20corridor%20at%20midnight%20with%20a%20single%20open%20door%20sickly%20green%20and%20dark%20teal%20tones%20unsettling%20volumetric%20light%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-clinic-14&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Empty%20dim%20hospital%20corridor%20at%20night%20with%20flickering%20fluorescent%20lights%20and%20long%20shadows%20sickly%20green%20and%20teal%20tones%20unsettling%20cinematic%20horror%20still%20no%20text&width=1200&height=675&seq=ptv-backdrop-clinic-14&orientation=landscape',
    tagline: '有些病人，不该被叫醒',
    synopsis:
      '新任夜班医生抵达一间位于郊外的老旧诊所，却发现这里的病例记录充满矛盾。随着夜班一次次到来，她开始意识到，这间诊所真正需要治疗的，或许并不是病人。',
    features:
      '以心理惊悚为主，克制使用跳吓，靠氛围与细节累积恐惧。每集一个独立病例，又由一条暗线串联，悬念引人入胜。',
  },
  {
    id: 15,
    title: '东京食记',
    type: 'tv',
    year: 2024,
    rating: 8.4,
    region: '日韩',
    genres: ['家庭', '剧情'],
    director: '小林悠平',
    actors: ['森川遥', '藤井澈', '中谷纱'],
    duration: '每集30分钟 / 共24集',
    updatedAt: '2025-08-12',
    hot: 6890,
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20Japanese%20food%20drama%20poster%20artwork%20of%20a%20steaming%20bowl%20of%20ramen%20on%20a%20wooden%20table%20in%20a%20cozy%20izakaya%20warm%20amber%20and%20soft%20cream%20tones%20inviting%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-food-15&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20izakaya%20interior%20at%20evening%20with%20warm%20lanterns%20and%20steaming%20dishes%20on%20a%20counter%20soft%20amber%20tones%20cinematic%20film%20still%20heartwarming%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-food-15&orientation=landscape',
    tagline: '一碗热汤，治愈一整天',
    synopsis:
      '东京一条小巷深处，有一家只在深夜营业的小食堂。沉默寡言的老板用一碗碗家常菜，招待着深夜归来的形形色色的客人，也倾听他们藏在食物背后的故事。',
    features:
      '每集以一个食客的故事为主，温暖治愈又带着淡淡的现实感。美食拍摄极具食欲，配乐轻柔，是纯粹的「深夜食堂」式治愈之作。',
  },
  {
    id: 16,
    title: '青春抛物线',
    type: 'tv',
    year: 2025,
    rating: 7.7,
    region: '国产',
    genres: ['校园', '剧情', '青春'],
    director: '夏鸣',
    actors: ['陈屿', '林喆', '苏禾', '邓一诺'],
    duration: '每集40分钟 / 共30集',
    updatedAt: '2025-10-01',
    hot: 7120,
    poster:
      'https://readdy.ai/api/search-image?query=Bright%20coming%20of%20age%20school%20drama%20poster%20artwork%20of%20teenagers%20on%20a%20sunlit%20sports%20field%20optimistic%20sky%20blue%20and%20warm%20golden%20tones%20nostalgic%20cinematic%20key%20art%20no%20text&width=400&height=600&seq=ptv-poster-youth-16&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Sunlit%20high%20school%20campus%20track%20with%20golden%20afternoon%20light%20and%20green%20trees%20warm%20nostalgic%20tones%20cinematic%20film%20still%20youthful%20energetic%20atmosphere%20no%20text&width=1200&height=675&seq=ptv-backdrop-youth-16&orientation=landscape',
    tagline: '那段奋力起跳的日子，永不落幕',
    synopsis:
      '高三那年，一群成绩平平的少年因为一场校园比赛走到一起。他们在学业、友情与梦想之间跌跌撞撞，也逐渐明白成长从来不是一条直线，而是一道起起落落的抛物线。',
    features:
      '青春气息扑面而来，台词接地气。剧集没有刻意煽情，而是用真实的校园细节唤起观众对少年时代的共鸣。',
  },
];